import * as React from "react";

const SvgComponent = (props) => (
  <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 13.508a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 2.25a3.75 3.75 0 1 0 0 7.499 3.75 3.75 0 0 0 0-7.5Zm0-7.508c6.92 0 12.894 4.725 14.551 11.346a1.125 1.125 0 1 1-2.182.547 12.756 12.756 0 0 0-24.74.006 1.126 1.126 0 0 1-2.183-.544A15.004 15.004 0 0 1 18 8.25Z"
      fill="#000"
      fill-opacity="0.4"
    />
  </svg>
);

export default SvgComponent;
